export default __webpack_public_path__ + "static/media/modo.7fa1fbac.svg";